import { lib } from '@gocanvas/client'

const {
  TEXT_STYLE,
  TEXT_USER_NAME_STYLE,
  TEXT_COMPANY_NAME_STYLE,
  TEXT_FIRST_NAME_STYLE,
  TEXT_LAST_NAME_STYLE,
  TEXT_FULL_NAME_STYLE,
  TEXT_CUSTOMER_CODE_STYLE,
  TEXT_SITE_CODE_STYLE,
  TEXT_PROJECT_CODE_STYLE,
  TEXT_GOCANVAS_USER_ID_STYLE,
} = lib

// TODO: remove flag check when gocanvas_user_id_system_default is fully rolled out
// Studio exposes the hash as `featureFlags`, Builder 3 as `feature_flags` — check both.
const gocanvasUserIdSystemDefaultEnabled = () => {
  const flags =
    window.initialOnboardingState?.featureFlags ??
    window.initialOnboardingState?.feature_flags
  return Boolean(flags?.gocanvas_user_id_system_default)
}

export const buildTextSystemDefaultOptions = projectSupport => {
  const standardSysDefaultOptions = [
    { value: TEXT_STYLE, label: 'None' },
    ...(gocanvasUserIdSystemDefaultEnabled()
      ? [{ value: TEXT_GOCANVAS_USER_ID_STYLE, label: 'User ID (GoCanvas)' }]
      : []),
    { value: TEXT_USER_NAME_STYLE, label: 'Username' },
    { value: TEXT_COMPANY_NAME_STYLE, label: 'Company Name' },
    { value: TEXT_FIRST_NAME_STYLE, label: 'First Name' },
    { value: TEXT_LAST_NAME_STYLE, label: 'Last Name' },
    { value: TEXT_FULL_NAME_STYLE, label: 'Full Name' },
  ]

  const projectSysDefaultOptions = [
    { value: TEXT_CUSTOMER_CODE_STYLE, label: 'Customer Code' },
    { value: TEXT_SITE_CODE_STYLE, label: 'Site Code' },
    { value: TEXT_PROJECT_CODE_STYLE, label: 'Project Code' },
  ]

  return projectSupport
    ? [...standardSysDefaultOptions, ...projectSysDefaultOptions]
    : standardSysDefaultOptions
}
